import * as React from "react";

interface Props {
    percentage: number | null;
    size?: number;
    strokeWidth?: number;
    showLabel?: boolean;
    color?: string;
}

function getColor(percentage: number): string {
    if (percentage >= 75) return "#22c55e";
    if (percentage >= 50) return "#eab308";
    if (percentage >= 25) return "#f97316";
    return "#ef4444";
}

export function CoverageDonut({ percentage, size = 44, strokeWidth = 5, showLabel = true, color }: Props) {
    const hasValue = percentage != null && Number.isFinite(percentage);
    const clamped = hasValue ? Math.max(0, Math.min(100, percentage)) : 0;
    const radius = (size - strokeWidth) / 2;
    const circumference = 2 * Math.PI * radius;
    const dash = (clamped / 100) * circumference;
    const strokeColor = hasValue ? (color ?? getColor(clamped)) : "#d1d5db";

    return (
        <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
            <svg width={size} height={size} className="-rotate-90">
                <circle
                    cx={size / 2}
                    cy={size / 2}
                    r={radius}
                    fill="none"
                    stroke="#e5e7eb"
                    strokeWidth={strokeWidth}
                />
                {hasValue && (
                    <circle
                        cx={size / 2}
                        cy={size / 2}
                        r={radius}
                        fill="none"
                        strokeWidth={strokeWidth}
                        strokeLinecap="round"
                        strokeDasharray={`${dash} ${circumference - dash}`}
                        style={{ stroke: strokeColor }}
                    />
                )}
            </svg>
            {showLabel && (
                <span
                    className="absolute font-semibold text-gray-700"
                    style={{ fontSize: size * 0.24 }}
                >
                    {hasValue ? `${Math.round(clamped)}%` : "–"}
                </span>
            )}
        </div>
    );
}
